import { render, staticRenderFns } from "./GroupButtons.vue?vue&type=template&id=442faee1&"
import script from "./GroupButtons.vue?vue&type=script&lang=js&"
export * from "./GroupButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports